import { ApiService } from '@services/api';
import { LONG_API_DOMAIN } from '@constants/api';
import {
  ISyncTikTokCampaigns,
  IUpdateTikTokCampaign,
} from '@domain/interfaces/dashboard/AdSense/TikTok/ITikTokCampaign';

export class TikTokCampaignService {
  private readonly apiService: ApiService;

  constructor(baseURL: string) {
    this.apiService = new ApiService(baseURL);
  }

  public syncTikTokCampaigns({ storeAliasId }: ISyncTikTokCampaigns): Promise<any> {
    return this.apiService.post(
      `/api/v1/users/stores/${storeAliasId}/tiktok/ad-sense-campaigns/sync`,
    );
  }

  public updateTikTokCampaign({
    adSenseCampaignAliasId,
    data,
    productAliasId,
    storeAliasId,
  }: IUpdateTikTokCampaign): Promise<any> {
    return this.apiService.put(
      `/api/v1/users/stores/${storeAliasId}/products/${productAliasId}/tiktok/ad-sense-campaigns/${adSenseCampaignAliasId}`,
      { ...data },
    );
  }
}

const tiktokCampaignService = new TikTokCampaignService(LONG_API_DOMAIN);

export default tiktokCampaignService;
